import { FC } from 'react';
import { DialogSessionActions } from '@/features/DialogSession';
import { formatTimeInterval, parseTimeToSeconds, type TimeIntervalFormat } from '@/shared/lib';

type Props = {
  /** Момент записи, к которому ведёт метка: `MM:SS` или `H:MM:SS` — так, как записан в тексте комментария */
  time: string;
  /** Формат показа метки: своя настройка есть у каждого места, где комментарий показан */
  format: TimeIntervalFormat;
  className?: string;
};

/**
 * Метка момента записи в тексте комментария: ведёт к этому моменту записи.
 *
 * Показывается в переданном формате отображения; сама запись таймкода
 * в тексте комментария при этом остаётся прежней.
 */
export const TimeFragmentLink: FC<Props> = ({ time, format, className }) => {
  const label = formatTimeInterval(parseTimeToSeconds(time), format);

  return (
    <DialogSessionActions clickAction={'scrollTo'} actions={['play', 'stop']} time={time} className={className}>
      {`[${label}]`}
    </DialogSessionActions>
  );
};
